import { render, staticRenderFns } from "./SearchInputField.vue?vue&type=template&id=6bdfe645&scoped=true"
import script from "./SearchInputField.vue?vue&type=script&lang=js"
export * from "./SearchInputField.vue?vue&type=script&lang=js"
import style0 from "./SearchInputField.vue?vue&type=style&index=0&id=6bdfe645&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdfe645",
  null
  
)

export default component.exports